export function formatNumber(value: number | undefined | null): string {
  if (value === undefined || value === null) {
    return '0';
  }

  if (value >= 1_000_000_000) {
    return `${(value / 1_000_000_000).toFixed(1)}B`;
  }
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}k`;
  }
  return value.toLocaleString('pt-BR');
}

export function formatPercentage(value: number | undefined | null): string {
  if (value === undefined || value === null) {
    return '0%';
  }
  return `${value.toFixed(1)}%`;
}